import { Component, OnInit, Input, ViewChild, EventEmitter, Output, Inject, Optional, ElementRef } from '@angular/core';
import {
  CheckSuitabilityDataObj,
  CheckInterviewSchDataObj,
  CheckstatusChangeObj,
  CorrespondenceDataObj,
  HrPanelInterviewObj,
} from '../../../shared/models/activity-dashboard-model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivityDialogComponent } from '../activity-dialog/activity-dialog.component';
import { SchedulerCandidate } from 'src/app/shared/models/schedulerAssociate';
import { ActivityCheckSuitabilityComponent } from '../activity-check-suitability/activity-check-suitability.component';
import { ActivityCorrespondenceComponent } from '../activity-correspondence/activity-correspondence.component';
import { ActivityScheduleinterviewComponent } from '../activity-scheduleinterview/activity-scheduleinterview.component';
import { ActivityStatusChangeComponent } from '../activity-status-change/activity-status-change.component';
import { ActivityHRInterviewComponent } from 'src/app/modules/activities/activity-hrinterview/activity-hrinterview.component';
import { CoupledStatuschangeActivityComponent } from '../coupled-statuschange-activity/coupled-statuschange-activity.component';
import { CoupledSuitabilityActivityComponent } from '../coupled-suitability-activity/coupled-suitability-activity.component';
import { CoupledCorrespoandenceActivityComponent } from '../coupled-correspoandence-activity/coupled-correspoandence-activity.component';
import { CoupledSchdueleInterviewActivityComponent } from '../coupled-schduele-interview-activity/coupled-schduele-interview-activity.component';
import { CoupledHrpanelInterviewActivityComponent } from '../coupled-hrpanel-interview-activity/coupled-hrpanel-interview-activity.component';
@Component({
  selector: 'app-coupled-activity',
  templateUrl: './coupled-activity.component.html',
  styleUrls: ['./coupled-activity.component.scss'],
  standalone: false,
})
export class CoupledActivityComponent implements OnInit {
  @Input() checkSuitabilityDataObj: CheckSuitabilityDataObj;
  @Input() checkInterviewSchDataObj: CheckInterviewSchDataObj;
  @Input() checkStatusChangeObj: CheckstatusChangeObj;
  @Input() correspondenceDataObj: CorrespondenceDataObj;
  @Input() checkHrPanelInterviewObj: HrPanelInterviewObj;

  @Input() coupledcheckSuitabilityDataObj: CheckSuitabilityDataObj;
  @Input() coupledcheckInterviewSchDataObj: CheckInterviewSchDataObj;
  @Input() coupledcheckStatusChangeObj: CheckstatusChangeObj;
  @Input() coupledcorrespondenceDataObj: CorrespondenceDataObj;
  @Input() coupledcheckHrPanelInterviewObj: HrPanelInterviewObj;

  @Input() onSuitability: boolean;
  @Input() onCorrespondence: boolean;
  @Input() onInterviewSchedule: boolean;
  @Input() onStatusChangeSchedule: boolean;
  @Input() onHrPanelInterview: boolean;

  @Input() onCoupledSuitability: boolean;
  @Input() onCoupledCorrespondence: boolean;
  @Input() onCoupledInterviewSchedule: boolean;
  @Input() onCoupledStatusChangeSchedule: boolean;
  @Input() onCoupledHrPanelInterview: boolean;

  @Input() selectedCandidate: SchedulerCandidate[];
  @Input() candidateApplicationIds: number[];
  @Input() ifCoupled: boolean;
  @Input() candidateEmails: string[];
  @Input() interviewFlag: boolean;
  @Input() editactivity: any;

  @Input() editcheckSuitabilityDataObj: CheckSuitabilityDataObj;
  @Input() editcandidateApplicationIds: number[];
  @Input() editcheckCorrespondenceDataObj: CorrespondenceDataObj;
  @Input() editcheckInterviewDataObj: CheckInterviewSchDataObj;
  @Input() editcheckStatusChangeDataObj: CheckstatusChangeObj;
  @Input() editcheckHrPanelInterviewObj: HrPanelInterviewObj;

  // @Input() coupledEditCheckSuitabilityDataObj:CheckSuitabilityDataObj;
  // @Input() coupledEditCheckSuitabilityDataObj2:CheckSuitabilityDataObj;
  // @Input() coupledEditCheckCorrespondenceDataObj:CorrespondenceDataObj;
  // @Input() coupledEditCheckInterviewDataObj:CheckInterviewSchDataObj;
  // @Input() coupledEditCheckStatusChangeDataObj:CheckstatusChangeObj;
  // @Input() coupledEditCheckHrPanelInterviewObj:HrPanelInterviewObj;

  @Input() test;
  coupledValid: boolean = false;
  singleValid: boolean = false;
  isCollapsed: boolean = false;
  formValid: boolean = false;
  createdonEdit: any;
  isSelected: boolean = false;
  reasonlist: any;
  activityId: any;
  readonly hiddenCommunicationReasonIds = ['102', '126', '141'];
  // isCollapsed: boolean = true;
  @ViewChild('submitBtn') coupledSendBtn: ElementRef;
  @ViewChild(ActivityCheckSuitabilityComponent) checkSuitability: ActivityCheckSuitabilityComponent;
  @ViewChild(ActivityCorrespondenceComponent) correspondence: ActivityCorrespondenceComponent;
  @ViewChild(ActivityScheduleinterviewComponent) scheduleInterview: ActivityScheduleinterviewComponent;
  @ViewChild(ActivityStatusChangeComponent) statusChange: ActivityStatusChangeComponent;
  @ViewChild(ActivityHRInterviewComponent) hrpanel: ActivityHRInterviewComponent;

  // @ViewChild('ccValue',static:false) myInput: ElementRef;
  @ViewChild(CoupledSuitabilityActivityComponent) coupledcheckSuitability: CoupledSuitabilityActivityComponent;
  @ViewChild(CoupledCorrespoandenceActivityComponent) coupledcorrespondence: CoupledCorrespoandenceActivityComponent;
  @ViewChild(CoupledSchdueleInterviewActivityComponent)
  coupledscheduleInterview: CoupledSchdueleInterviewActivityComponent;
  @ViewChild(CoupledStatuschangeActivityComponent) coupledstatusChange: CoupledStatuschangeActivityComponent;
  @ViewChild(CoupledHrpanelInterviewActivityComponent) coupledhrpanel: CoupledHrpanelInterviewActivityComponent;

  @Output() refreshcandiates: EventEmitter<any> = new EventEmitter();

  constructor(
    private elementref: ElementRef,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.checkSuitabilityDataObj = data.checkSuitabilityDataObj;
      this.coupledcheckSuitabilityDataObj = data.coupledcheckSuitabilityDataObj;

      this.correspondenceDataObj = data.correspondenceDataObj;
      this.coupledcorrespondenceDataObj = data.coupledcorrespondenceDataObj;

      this.checkInterviewSchDataObj = data.checkInterviewSchDataObj;
      this.coupledcheckInterviewSchDataObj = data.coupledcheckInterviewSchDataObj;

      this.checkStatusChangeObj = data.checkStatusChangeObj;
      this.coupledcheckStatusChangeObj = data.coupledcheckStatusChangeObj;

      this.checkHrPanelInterviewObj = data.checkHrPanelInterviewObj;
      this.coupledcheckHrPanelInterviewObj = data.checkHrPanelInterviewObj;

      // this.editcheckStatusChangeDataObj=data.checkStatusChangeObj;
      // this.editcheckInterviewDataObj=data.checkInterviewSchDataObj;
      // this.editcheckHrPanelInterviewObj=data.checkHrPanelInterviewObj;

      // // this.coupledEditCheckSuitabilityDataObj2=data.coupledcheckSuitabilityDataObj;
      // this.coupledEditCheckCorrespondenceDataObj=data.coupledcorrespondenceDataObj;
      // this.coupledEditCheckInterviewDataObj=data.coupledcheckInterviewSchDataObj;
      // this.coupledEditCheckStatusChangeDataObj=data.coupledcheckStatusChangeObj;
      // this.coupledEditCheckHrPanelInterviewObj=data.coupledcheckHrPanelInterviewObj;

      this.onCoupledSuitability = data.onCoupledSuitability;
      this.onCoupledCorrespondence = data.onCoupledCorrespondence;
      this.onCoupledHrPanelInterview = data.onCoupledHrPanelInterview;
      this.onCoupledStatusChangeSchedule = data.onCoupledStatusChangeSchedule;
      this.onCoupledInterviewSchedule = data.onCoupledInterviewSchedule;

      this.onSuitability = data.onSuitability;
      this.onCorrespondence = data.onCorrespondence;
      this.onHrPanelInterview = data.onHrPanelInterview;
      this.onInterviewSchedule = data.onInterviewSchedule;
      this.onStatusChangeSchedule = data.onStatusChangeSchedule;

      this.editactivity = data.editActivity;
      // this.isCollapsed = data.editActivity;
      this.isCollapsed = true;
      this.ifCoupled = data.ifCoupled;
      this.selectedCandidate = data.selectedCandidate;
      this.candidateEmails = data.candidateEmails;
    }
  }

  ngOnInit() {
    this.isCollapsed = true;
    console.log(this.ifCoupled);
    console.log(this.isCollapsed);
    console.log(this.selectedCandidate);
    console.log('inside coupled');
    console.log(this.onCorrespondence);
    console.log(this.onSuitability);
    console.log(this.onCoupledSuitability);
    console.log(this.onStatusChangeSchedule);
    // console.log(this.coupledEditCheckSuitabilityDataObj);
    // console.log(this.coupledEditCheckSuitabilityDataObj2);
    console.log(this.checkSuitabilityDataObj);
    console.log(this.coupledcheckSuitabilityDataObj);

    // console.log('testing singleAS form ', this.singleValid);
    // this.showMoreLess();
  }
  refreshCoupledcorres(_event) {
    this.refreshcandiates.emit('true');
    this.showMoreLess();
  }
  createdOnValue1(event) {
    this.createdonEdit = event;
  }

  createdOnValue(event)
  {
    console.log("event--",event)
    if (this.coupledcheckSuitabilityDataObj !== undefined)//|| this.checkSuitabilityDataObj!==null)
      {
        this.coupledcheckSuitability.activityAction();
        // console.log("save done checksuitbaility");
      }
      if (this.coupledcorrespondenceDataObj !== undefined)// || this.correspondenceDataObj!==null)
      {
        if (!this.hideCoupledCommunicationForSelectedReason()) {
          if(event && event.toLowerCase() == 'raul'){
            this.refreshCoupledcorres('');
          }
          else{
            this.coupledcorrespondence.send(event);//saveCorresActivity();
            // console.log("save done correspondence")
          }
        }
      }
      if (this.coupledcheckInterviewSchDataObj !== undefined) //this.checkInterviewSchDataObj!==null)
      {
        console.log("inside checkinterview in coupled");
        console.log('couped interview obj', this.coupledcheckInterviewSchDataObj);

      this.coupledscheduleInterview.send();
      // console.log("save done interview");
    }
    if (this.coupledcheckStatusChangeObj !== undefined) //|| this.checkStatusChangeObj!==null)
    {
      this.coupledstatusChange.send();
      // console.log("save done status change");
    }
    if (this.coupledcheckHrPanelInterviewObj !== undefined) {
      this.coupledhrpanel.send();
    }
    // this.refreshcandiates.emit("true");
  }

  // ngAfterViewInit() {
  //   this.coupledSendBtn.nativeElement.focus();
  // }

  coupledformValid(event) {
    this.coupledValid = event;
    // console.log('couple', this.coupledValid);
    this.updateSubmit();
    // this.coupledSendBtn.nativeElement.focus();

  }

  updateReasonlist(event) {
    this.reasonlist = event;
    if (this.hideCoupledCommunicationForSelectedReason()) {
      this.coupledValid = true;
      this.updateSubmit();
    }
    else if (this.onCoupledCorrespondence) {
      this.coupledValid = false;
      this.updateSubmit();
    }
  }

  hideCoupledCommunicationForSelectedReason(): boolean {
    const selectedReason = this.reasonlist;
    const reasonId = Array.isArray(selectedReason) ? selectedReason[0] : selectedReason && selectedReason.value !== undefined ? selectedReason.value : selectedReason;

    return this.hiddenCommunicationReasonIds.indexOf((reasonId || '').toString()) > -1;
  }
  singleformValid(event) {
    this.singleValid = event;
    // console.log('single', this.singleValid);
    this.updateSubmit();
    // this.coupledSendBtn.nativeElement.focus();
  }
  updateSubmit() {
    if (this.singleValid && this.coupledValid) {
      this.formValid = true;
    } else {
      this.formValid = false;
    }
    // console.log('formvalid', this.formValid);
  }

  saveCoupledActivity() {
    if (this.formValid) {
        if (this.coupledcorrespondenceDataObj !== undefined && !this.hideCoupledCommunicationForSelectedReason() && this.coupledcorrespondence && this.coupledcorrespondence.isCandidateCommunicationRequired()) {
        this.coupledcorrespondence.showCandidateCommunicationRequiredMessage();
        return;
      }

      console.log(this.checkSuitabilityDataObj);
      console.log(this.checkInterviewSchDataObj);
      console.log(this.checkStatusChangeObj);
      console.log(this.correspondenceDataObj);
      console.log('statuts obj', this.checkStatusChangeObj);
      console.log('coupled status obj', this.coupledcheckStatusChangeObj);
      console.log('couped interview obj', this.coupledcheckInterviewSchDataObj);
      if (this.checkSuitabilityDataObj !== undefined) //|| this.checkSuitabilityDataObj!==null)
      {
        this.checkSuitability.activityAction();
        // console.log("save done checksuitbaility");
      }
      if (this.correspondenceDataObj !== undefined) // || this.correspondenceDataObj!==null)
      {
        this.correspondence.saveCorresActivity();
        // console.log("save done correspondence")
      }
      if (this.checkInterviewSchDataObj !== undefined) //this.checkInterviewSchDataObj!==null)
      {
        console.log('inside checkinterview in coupled');
        this.scheduleInterview.send();
        // console.log("save done interview");
      }
      if (this.checkStatusChangeObj !== undefined) //|| this.checkStatusChangeObj!==null)
      {
        this.statusChange.send();
        // console.log("save done status change");
        if (this.hideCoupledCommunicationForSelectedReason()) {
          this.refreshcandiates.emit("true");
        }
      }
      if (this.checkHrPanelInterviewObj !== undefined) {
        this.hrpanel.send();
      }

      //------coupled activity call

      // if (this.coupledcheckSuitabilityDataObj !== undefined)//|| this.checkSuitabilityDataObj!==null)
      // {
      //   this.coupledcheckSuitability.activityAction();
      //   // console.log("save done checksuitbaility");
      // }
      // if (this.coupledcorrespondenceDataObj !== undefined)// || this.correspondenceDataObj!==null)
      // {
      //   this.coupledcorrespondence.send();//saveCorresActivity();
      //   // console.log("save done correspondence")
      // }
      // if (this.coupledcheckInterviewSchDataObj !== undefined) //this.checkInterviewSchDataObj!==null)
      // {
      //   console.log("inside checkinterview in coupled");
      //   console.log('couped interview obj', this.coupledcheckInterviewSchDataObj);

      //   this.coupledscheduleInterview.send();
      //   // console.log("save done interview");
      // }
      // if (this.coupledcheckStatusChangeObj !== undefined) //|| this.checkStatusChangeObj!==null)
      // {
      //   this.coupledstatusChange.send();
      //   // console.log("save done status change");
      // }
      // if (this.coupledcheckHrPanelInterviewObj !== undefined) {
      //   this.coupledhrpanel.send();
      // }
      // this.refreshcandiates.emit("true");
      // this.showMoreLess();
    }
  }
  showMoreLess() {
    this.isCollapsed = !this.isCollapsed;
  }
}
